const codesFor8PinSOIC = [
  'R-8', //standard SOIC
  '05-08-1610', //LTC SOIC
];
const codesFor8PinSOICEP = [
  'RD-8-1', //SOIC with exposed pad
  'RD-8-2', //SOIC with exposed pad
  '05-08-1857', //LTC SOIC with exposed pad
];
const codesFor8PinMSOP = [
  'RM-8', //standard MSOP
  '05-08-1660', //LTC MSOP
];
const codesFor8PinMSOPEP = [
  'RH-8-1', //MSOP with exposed pad
  'RH-8-3', //MSOP with exposed pad
  'RH-8-4', //MSOP with exposed pad
  '05-08-1662', //LTC MSOP with exposed pad
];
const codesForSOT23 = [
  'RJ-5', //5 pin SOT-23
  'RJ-6', //6 pin SOT-23
  '05-08-1635', //LTC 5 pin SOT-23
  '05-08-1636', //LTC 6 pin SOT-23
];

export function isSOIC(packagecode) {
  return packageChecker(packagecode, codesFor8PinSOIC);
}
export function isSOICEP(packagecode) {
  return packageChecker(packagecode, codesFor8PinSOICEP);
}
export function isMSOP(packagecode) {
  return packageChecker(packagecode, codesFor8PinMSOP);
}
export function isMSOPEP(packagecode) {
  return packageChecker(packagecode, codesFor8PinMSOPEP);
}
export function isSOT23(packagecode) {
  return packageChecker(packagecode, codesForSOT23);
}

// Returns true if package matches an item in the package code list.
export function packageChecker(codeToCheck, codeListToCheckAgainst) {
  return codeListToCheckAgainst.some((item) => {
    /* some means at least one returns true */
    return codeToCheck.indexOf(item) > -1; /* true if codeToCheck has the item buried in it somewhere */
  });
}
